import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Box, Button } from "@mui/material";
import { RequestMode } from "@/types/common";
import { RowRequestType } from "@/types/view";
import { ApiConstant, AppConstant, LangConstant } from "@/const";
import { StatusExternalRequest, StatusInternalRequest, StatusQueryResponse } from "@/components/common";
import { GridColDef } from "@/components/common/AppTable/AppTable";
import { Fragment } from "react";

const useRequestColumn = (mode: RequestMode) => {
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);

  const columnList: GridColDef<RowRequestType>[] = [
    {
      field: "requestId",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.requestID"),
      align: "left",
    },
    {
      field: "applicationSendName",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.application"),
      align: "center",
    },
    {
      field: "createdAt",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.createdAt"),
      align: "center",
      render: (cell: RowRequestType) => {
        return (
          cell.createdAt && (
            <Box>
              {dayjs(cell.createdAt).format(AppConstant.FM_SHORT_DATE)}
              <br />
              {dayjs(cell.createdAt).format(AppConstant.FM_FULL_HOUR)}
            </Box>
          )
        );
      },
    },
    {
      field: "responseAt",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.responseAt"),
      align: "center",
      render: (cell: RowRequestType) => {
        return (
          cell.responseAt && (
            <Box>
              {dayjs(cell.responseAt).format(AppConstant.FM_SHORT_DATE)}
              <br />
              {dayjs(cell.responseAt).format(AppConstant.FM_FULL_HOUR)}
            </Box>
          )
        );
      },
    },
    {
      field: "status",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.status"),
      align: "center",
      render: (cell: RowRequestType) => (
        <Fragment>
          {mode === "internal" && <StatusInternalRequest status={cell.status} />}
          {mode === "external" && <StatusExternalRequest status={cell.status} />}
          {mode === "queryResponse" && <StatusQueryResponse status={cell.status} />}
        </Fragment>
      ),
    },
    {
      field: "responseStatus",
      headerName: getLabel("OBJ_INTERNAL_TABLE_COL.responseStatus"),
      align: "center",
      render: (cell: RowRequestType) => {
        if (cell.transferResponseData) {
          return (
            <Button
              sx={{ width: 180 }}
              variant="outlined"
              color={cell.transferResponseData.statusCode === ApiConstant.HTTP_STATUS.STT_OK ? "success" : "error"}
            >
              {getLabel(
                cell.transferResponseData.statusCode === ApiConstant.HTTP_STATUS.STT_OK
                  ? "OBJ_RESPONSE_STATUS.success"
                  : "OBJ_RESPONSE_STATUS.error",
              )}
            </Button>
          );
        }
        return (
          <Button sx={{ width: 180 }} variant="outlined" color="warning">
            {getLabel("OBJ_RESPONSE_STATUS.processing")}
          </Button>
        );
      },
    },
  ];

  return {
    columnList,
  };
};

export default useRequestColumn;
